<template>
  <div>
    <driven-header />
    <router-view v-slot="{ Component }">
      <div class="header-margin" />
      <car-header v-if="!Component?.type.hideCarHeader" />
      <transition name="scale" mode="out-in">
        <div :class="{ 'force-mobile': !Component?.type.isIndexPage }">
          <component :is="Component" />
        </div>
      </transition>
    </router-view>
    <driven-footer v-if="!$route.meta.hideFooter" />
  </div>
</template>
<script>
import DrivenHeader from "@/components/DrivenHeader";
import DrivenFooter from "@/components/DrivenFooter";
import CarHeader from "@/cars/CarHeader";
import { mapActions, mapMutations } from "vuex";

export default {
  components: { CarHeader, DrivenHeader, DrivenFooter },
  props: {
    csrf: String,
    initObject: String,
  },
  methods: {
    ...mapActions("accounts", ["getUser"]),
    ...mapMutations(["setInitObject"]),
  },
  mounted() {
    this.getUser();
    this.setInitObject(this.initObject);
  },
};
</script>
<style>
:root {
  --bs-body-color: #000000;
  --bs-dark: #000000;
  --brand-gradient: linear-gradient(202.17deg, #ff00d6 8.58%, #0072db 91.42%);
  --brand-gradient-lighter: linear-gradient(
    202.17deg,
    #ff00d6 8.58%,
    #58b2ff 91.42%
  );
  --brand-color: rgba(0, 114, 219, 1);
  --bs-gutter-x: 20px;
  --brand-pink: #ff266e;
}

.mt-li {
  margin-top: 10px;
}

.mt-xs {
  margin-top: 20px !important;
}

.mt-sm {
  margin-top: 30px !important;
}

.mt-md {
  margin-top: 50px !important;
}

.mt-lg {
  margin-top: 120px !important;
}

.mb-lg {
  margin-bottom: 120px !important;
}

.intro-text {
  font-size: 32px;
}

.intro-subtext {
  font-size: 28px;
}

.btn-width {
  width: 269px;
}

h1,
h2,
h3,
h4,
h5,
h6 {
  font-family: "Comfortaa", "sans-serif";
}

h1 {
  font-size: 32px !important;
}

div,
ul,
li {
  font-family: "Roboto", "sans-serif";
}

.bg-brand {
  background-color: #0072db;
  color: white;
}

.bg-brand div {
  font-family: Comfortaa, serif;
}

.scale-enter-active {
  transition: all 0.3s ease-in-out;
}

.scale-enter-from {
  opacity: 0;
}

.force-mobile {
  max-width: 960px !important;
  margin-left: auto;
  margin-right: auto;
}

.deforce-mobile {
  width: 100vw !important;
}

@media (min-width: 960px) {
  .deforce-mobile {
    margin-left: calc((960px - 100vw) / 2);
  }
}

#djDebugToolbarHandle {
  top: 150px !important;
}

.noscroll {
  overflow: hidden;
  height: 20px;
}

.header-margin {
  height: 72px;
}

.list-group-item {
  position: static !important;
}
</style>
